navBar.classy.controller({
    name: 'NavbarNotificationsController',
    inject: ['$scope', '$modal', '$sce', '$http', '$q',
        'authServiceFactory', 'ApplicationService', 'NotificationModelService'],
    init: function()
    {
        this.$.$sce = this.$sce; 
        this.$.NotificationModelService = this.NotificationModelService;
        this.$.authServiceFactory = this.authServiceFactory;
        
        var auth = this.authServiceFactory.getAuth();

        this.$.items = [];
        this.$q.when(this.NotificationModelService.get('')).then( (notifications) => {
            this.$.items = notifications;
            this.calcUnread();

            for (var i = 0; i < this.$.items.length; i++) {
                if (this.$.items[i].forceopen == 1 && this.$.items[i].viewedDate == null) {

                    this.$.items[i].viewedDate = moment().format('YYYY-mm-dd hh:mm:ss');
                    if (auth.isISMon == undefined || auth.isISMon == false) {
                        this.$http.put('/api/notifications/' + this.$.items[i].notificationID + "/viewedDate", this.$.items[i]).then( (results) => {
                            this.calcUnread();
                        });
                        this.$modal.open({
                            templateUrl: "fast/submodules/schoolside/navbar/partials/notificationModal.html?v=" + versionNo,
                            controller: "NotificationModalController",
                            resolve: {
                                item: function(NotificationModelService) {
                                    return NotificationModelService.get()[i];
                                },
                                index: function() {
                                    return i;
                                }
                            },
                            keyboard: false,
                            backdrop: 'static'
                        });
                    }

                }
            }
        });

    },
    watch: {
        'authServiceFactory.getAuth()': function(value)
        {
            this.calcUnread();
        }
    },
    calcUnread: function() {
        this.$.numUnread = 0;
        for (var i = 0; i < this.$.items.length; i++) {
            if (this.$.items[i].viewedDate==null) 
                this.$.numUnread++;
        }
    },
    momentFormat: function(datetime)
    {
        var notetime = moment(datetime)
        return notetime.format('MMM Do, YYYY h:mm a');
    },
    openNotification: function(index)
    {
        var parent = this;
        if (this.$.items[index].viewedDate==null && !this.authServiceFactory.getAuth().isISMon) {
            this.$http.put('/api/notifications/'+this.$.items[index].notificationID+"/viewedDate", this.$.items[index]).then(function(results) {
                if (results.data==1) {
                    var auth = parent.$.authServiceFactory.getAuth();
                    auth.notifications[index].viewedDate = moment().format('YYYY-mm-dd hh:mm:ss');
                    parent.$.authServiceFactory.set(auth);
                    parent.calcUnread();
                }
            });
        }
        this.$modal.open({
            templateUrl: "fast/submodules/schoolside/navbar/partials/notificationModal.html?v=" + versionNo,
            controller: "NotificationModalController",
            resolve: {
                item: function() {
                    return parent.$.items[index]
                },
                index: function() {
                    return index
                }
            },
            keyboard: false,
            backdrop: 'static'
        });
    }
});

navBar.classy.controller({
    name: 'NotificationModalController',
    inject: ['$scope', '$http', 'authServiceFactory', 'ApplicationService', '$modalInstance', 'NotificationModelService', '$modal', '$sce', 'item', 'index'],
    init: function()
    {
        this.$.$sce = this.$sce; 
        this.$.item = this.item;
        this.$.index = this.index;
        this.$.NotificationModelService = this.NotificationModelService;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.items = this.authServiceFactory.getAuth().notifications;
        this.$.$modalInstance = this.$modalInstance;
        this.$.versionNo = versionNo; // so that we can use the current version number inside notifications
    },
    momentFormat: function(datetime)
    {
        var notetime = moment(datetime)
        return notetime.format('MMM Do, YYYY h:mm a');
    }
});

// Angular compile directive so that we can write angular expressions inside notifications
navBar.directive('compile', function($compile) {
  // directive factory creates a link function
  return function(scope, element, attrs) {
    scope.$watch(
      function(scope) {
        // watch the 'compile' expression for changes
        return scope.$eval(attrs.compile);
      },
      function(value) {
        // when the 'compile' expression changes
        // assign it into the current DOM
        element.html(value);

        // compile the new DOM and link it to the current
        // scope.
        // NOTE: we only compile .childNodes so that
        // we don't get into infinite loop compiling ourselves
        $compile(element.contents())(scope);
      }
    );
  };
});
